// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Paste = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M16.56,10.21h-5c-1,0-1.81-.68-1.81-1.53s.81-1.52,1.81-1.52h5c1,0,1.81.68,1.81,1.52s-.81,1.53-1.81,1.53Z' />
      <path d='M18.37,8.68c0,.85-.81,1.53-1.81,1.53h-5c-1,0-1.81-.68-1.81-1.53s.81-1.52,1.81-1.52h5c1,0,1.81.68,1.81,1.52Z' />
      <path d='M5.99,36.95h-.9c-1.72,0-3.12-1.17-3.12-2.62V11.31c0-1.46,1.4-2.63,3.12-2.63h2.82' />
      <path d='M20.23,8.68h2.82c1.72,0,3.12,1.17,3.12,2.63v3.76' />
      <path d='M46.03,18.16v19.58c0,1.71-1.38,3.09-3.09,3.09H9.09c-1.71,0-3.1-1.38-3.1-3.09v-19.58c0-1.7,1.39-3.09,3.1-3.09h33.86c1.71,0,3.09,1.39,3.09,3.09Z' />
    </svg>
  );
};
